import { AddressTypes, FormValidation } from '../../../../global-types/addresses';

export enum addressStatus {
  INVALID = 'invalid',
  INCOMPLETE = 'incomplete',
}

export type SubmitEditedAddress = (address: FormValidation[]) => void;
export type OnEditAddress = (addressType: AddressTypes) => void;
export type OnSkipValidation = (validationAddresses: FormValidation[]) => void;

export type AddressConfirmationProps = {
  isOpen: boolean;
  onClose: () => void;
  onSkipValidation: OnSkipValidation;
  onEditAddress: OnEditAddress;
  addressesToValidate: FormValidation[];
  isAddressFromAddressBook: boolean;
  submitEditedAddress?: SubmitEditedAddress;
  onResubmitAddress?: () => void;
};

export type UseAddressValidationTextProps = {
  currentValidationAddress: FormValidation;
};

export type UseAddressValidiationTextReturn = {
  validationTitle: string;
  validationMessageKey: string;
};
